import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/lib/api";

/**
 * Fetches admin-set SEO overrides for a static page.
 * Returns { focus_keyword, meta_description, image_alt } or null while loading.
 * Pages should pass these through to the <SEO> component, falling back to their
 * own hardcoded defaults when a field is empty.
 */
export const usePageSeo = (pageKey) => {
  const [override, setOverride] = useState(null);

  useEffect(() => {
    let cancelled = false;
    if (!pageKey) return undefined;
    axios
      .get(`${API}/page-seo/${pageKey}`)
      .then((res) => {
        if (!cancelled) setOverride(res.data || null);
      })
      .catch(() => {
        if (!cancelled) setOverride(null);
      });
    return () => {
      cancelled = true;
    };
  }, [pageKey]);

  return override;
};
